// Wait for PagSeguro to be loaded
const waitForPagSeguro = () => {
    return new Promise((resolve, reject) => {
        if (window.PagSeguro) {
            resolve(window.PagSeguro);
            return;
        }

        // Check every 100ms if PagSeguro is loaded
        const checkInterval = setInterval(() => {
            if (window.PagSeguro) {
                clearInterval(checkInterval);
                resolve(window.PagSeguro);
            }
        }, 100);

        // Timeout after 10 seconds
        setTimeout(() => {
            clearInterval(checkInterval);
            reject(new Error('PagSeguro script failed to load'));
        }, 15000);
    });
};

export const createEncryptedCard = async (cardHolder, cardNumber, cardExpMonth, cardExpYear, cardCVC) => {
    try {
        // Wait for PagSeguro to be available
        const PagSeguro = await waitForPagSeguro();
        
        return PagSeguro.encryptCard({
            publicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr+ZqgD892U9/HXsa7XqBZUayPquAfh9xx4iwUbTSUAvTlmiXFQNTp0Bvt/5vK2FhMj39qSv1zi2OuBjvW38q1E374nzx6NNBL5JosV0+SDINTlCG0cmigHuBOyWzYmjgca+mtQu4WczCaApNaSuVqgb8u7Bd9GCOL4YJotvV5+81frlSwQXralhwRzGhj/A57CGPgGKiuPT+AOGmykIGEZsSD9RKkyoKIoc0OS8CPIzdBOtTQCIwrLn2FxI83Clcg55W8gkFSOS6rWNbG5qFZWMll6yl02HtunalHmUlRUL66YeGXdMDC2PuRcmZbGO5a/2tbVppW6mfSWG3NPRpgwIDAQAB",
            number: cardNumber,
            holder: cardHolder,
            expMonth: cardExpMonth,
            expYear: cardExpYear,
            securityCode: cardCVC
        });
    } catch (error) {
        console.error("Error creating encrypted card:", error);
        throw error;
    }
}
